import { render, staticRenderFns } from "./liveClassCourse.vue?vue&type=template&id=2cb1922d"
import script from "./liveClassCourse.vue?vue&type=script&lang=js"
export * from "./liveClassCourse.vue?vue&type=script&lang=js"
import style0 from "./liveClassCourse.vue?vue&type=style&index=0&id=2cb1922d&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports